import i18n from 'i18next';
import { Language } from '../types';

export const getAvailableLanguages = (): Language[] => {
  const supportedLngs = (i18n.options.supportedLngs as string[]) || [];
  // Filter to only return Language enum values (not locale codes like en-US)
  // by checking if they match the 2-letter language code pattern
  return supportedLngs.filter(lng => lng.length === 2) as Language[];
};
